import { FileModel } from '../../file.model';
import { LocalizedValueModel } from '../../localized-value.model';
import { RefProperty } from '../../ref-property.model';
import { MobileColorsCustomizationsPresenterModel } from './mobile-colors-customizations-presenter-models';

export class ThemePresenterModel {
  dark_colors_mobile_customization?: MobileColorsCustomizationsPresenterModel;
  dark_mode?: boolean;
  general_css?: null | FileModel;
  id?: string;
  light_colors_mobile_customization?: MobileColorsCustomizationsPresenterModel;
  theme_name: LocalizedValueModel;
  used_font?: Array<FontEntryPresenterModel>;
}

export class FontEntryPresenterModel {
  font_name: LocalizedValueModel;
  id?: string;
  language?: Array<RefProperty>;
  otf?: Array<null | FileModel>;
  ttf?: Array<null | FileModel>;
  woff?: Array<null | FileModel>;
  woff2?: Array<null | FileModel>;
}
